const int = async () => import("./playbooks/playbook-int.json");
const test = async () => import("./playbooks/playbook-test.json");
const prod = async () => import("./playbooks/playbook-prod.json");

const regionMapping = {int, test, prod};

export const responsePlaybook = (async function getPlaybookByRegion() {
  // Regions can be INT, TEST, PROD_US, PROD_EU, or PROD_APJC
  const region = (window.__SHELL__?.region ?? "INT")
    .split("_")[0] // transforms "PROD_XX" to "PROD"
    .toLowerCase();
  const json = await regionMapping[region]();
  return json;
})();
